<template>
  <div class="result">
    <!-- 弹框 -->
    <div class="model" v-if="status" @wheel.prevent @touchmove.prevent>
      <div class="modelContent box_sizing" style="width: 1000px;">
        <div class="title">翻译</div>
        <word ref="word"></word>
        <div class="zuoda box_sizing">
          <div
            class="clickable_html"
            style="height: 450px;overflow-y: auto;font-size: 16px;line-height: 40px;"
            v-html="contentHtml"
            @click="onWordClick"
            @wheel.stop
            @touchmove.stop
          ></div>
          <div class="close_btn" @click="status = false">关闭</div>
        </div>
        <div class="cancel" @click="status = false">
          <img src="../assets/images/login_close.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Word from "@/components/word.vue";
export default {
  name: "translate",
  components: {
    Word,
  },
  data() {
    return {
      status: false,
      content: ""
    };
  },
  computed: {
    /**
     * 翻译内容富文本（支持点击查词）。
     * @returns {string} 处理后的 HTML
     */
    contentHtml() {
      return this.wrapWordsInHtml(this.content || "");
    },
  },
  watch: {
    status(newVal) {
      if (newVal) {
        // 弹窗打开时，禁用body滚动
        document.body.style.overflow = 'hidden';
      } else {
        // 弹窗关闭时，恢复body滚动
        document.body.style.overflow = '';
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时恢复body滚动
    document.body.style.overflow = '';
  },
  methods: {

    /**
     * 处理富文本容器的点击事件（事件代理）。
     * 点击到被包裹的单词 span 时触发查词。
     * @param {MouseEvent} e 点击事件
     * @returns {void}
     */
    onWordClick(e) {
      const target = e && e.target;
      if (!target || !target.dataset) return;
      const word = target.dataset.word;
      if (!word) return;
      this.dianjiClick(word);
    },

    /**
     * 在保留原 HTML 标签结构/样式的前提下，将文本节点中的英文单词包裹为可点击 span。
     * - 保留 <br> 与常见块级标签的换行语义
     * - 忽略 script/style 等节点
     * @param {string} html 原始富文本 HTML
     * @returns {string} 处理后的 HTML
     */
    wrapWordsInHtml(html) {
      const raw = String(html || "");
      const withNewlines = raw
        .replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n")
        .replace(/<br\s*\/?>/gi, "<br/>")
        .replace(/<\/(p|div|li|tr|h[1-6])\s*>/gi, "</$1><br/>");

      const root = document.createElement("div");
      root.innerHTML = withNewlines;

      const wordRe = /[A-Za-z]+(?:[-'][A-Za-z]+)*/g;
      const wrapTextNode = (textNode) => {
        const text = textNode.nodeValue || "";
        if (!text) return;
        const frag = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        while ((match = wordRe.exec(text)) !== null) {
          const start = match.index;
          const end = start + match[0].length;
          if (start > lastIndex) {
            frag.appendChild(document.createTextNode(text.slice(lastIndex, start)));
          }
          const span = document.createElement("span");
          span.className = "click_word";
          span.dataset.word = match[0];
          span.textContent = match[0];
          frag.appendChild(span);
          lastIndex = end;
        }
        if (lastIndex < text.length) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex)));
        }
        textNode.parentNode && textNode.parentNode.replaceChild(frag, textNode);
      };

      const walk = (node) => {
        if (!node) return;
        if (node.nodeType === Node.ELEMENT_NODE) {
          const tag = (node.tagName || "").toLowerCase();
          if (tag === "script" || tag === "style") return;
          if (tag === "span" && node.dataset && node.dataset.word) return;
          const children = Array.from(node.childNodes);
          children.forEach(walk);
        } else if (node.nodeType === Node.TEXT_NODE) {
          wrapTextNode(node);
        }
      };

      walk(root);
      return root.innerHTML;
    },

    /**
     * 点击单词触发查词弹窗。
     * @param {string} item 单词
     * @returns {void}
     */
    dianjiClick(item) {
      if (!item || item == '&nbsp;' || item == '<br/>') {return;}
      this.$refs.word.word_text = item;
      this.$refs.word.getWord();
    },

  },
};
</script>
<style>
.clickable_html {
  line-height: 1.8;
  word-break: break-word;
}

.click_word {
  cursor: pointer;
}

.click_word:hover {
  text-decoration: underline;
}

.close_btn {
  width: 120px;font-size: 16px;color: #ffffff;border-radius: 100px;
  margin-top: 50px;background-color: #f6704b;line-height: 40px;text-align: center;
  cursor: pointer;margin-left: auto;
}
</style>
